"use strict";
// ***
// Types for display fields
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadFormInputValueType = exports.LeadFormFieldNameList = exports.LeadFormFieldNameVirtual = exports.LeadFormFieldNameReal = void 0;
/* START: Define a mixed (real Lead API Fields + and frontend-only (=virtual) input types) type/item list for Dropdown */
var LeadFormFieldNameReal;
(function (LeadFormFieldNameReal) {
    LeadFormFieldNameReal["givenName"] = "givenName";
    LeadFormFieldNameReal["familyName"] = "familyName";
    LeadFormFieldNameReal["telephone"] = "telephone";
    LeadFormFieldNameReal["email"] = "email";
    LeadFormFieldNameReal["birthYear"] = "birthYear";
    LeadFormFieldNameReal["country"] = "country";
})(LeadFormFieldNameReal = exports.LeadFormFieldNameReal || (exports.LeadFormFieldNameReal = {}));
var LeadFormFieldNameVirtual;
(function (LeadFormFieldNameVirtual) {
    LeadFormFieldNameVirtual["content"] = "content";
    LeadFormFieldNameVirtual["lead"] = "lead";
    LeadFormFieldNameVirtual["privacy"] = "privacy";
})(LeadFormFieldNameVirtual = exports.LeadFormFieldNameVirtual || (exports.LeadFormFieldNameVirtual = {}));
exports.LeadFormFieldNameList = Object.assign(Object.assign({}, LeadFormFieldNameReal), LeadFormFieldNameVirtual); // Using for referencing types in <template> block
var LeadFormInputValueType;
(function (LeadFormInputValueType) {
    LeadFormInputValueType["string"] = "string";
    LeadFormInputValueType["numeric"] = "numeric";
    LeadFormInputValueType["email"] = "email";
})(LeadFormInputValueType = exports.LeadFormInputValueType || (exports.LeadFormInputValueType = {}));
